//@ts-ignore
const { Features } = await import("uidispatcher_api/UidispatcherApiModule");

export default Features;
